import {
	IFilterDefinition,
	ISelectFilterDefinition,
	ITextFilterDefinition
} from '@evinced-private/ui-common';

import {
	DEFAULT_ENVIRONMENT_DISPLAY_NAME,
	DEFAULT_UNIT_ID_DISPLAY_NAME,
	ENVIRONMENT_LABEL_KEY,
	UNIT_ID_LABEL_KEY
} from 'src/common/consts/platformConfigConsts';

import { createSingleSelectFilter } from '../../helpers/FilterCreationHelpers';

const searchFilter: ITextFilterDefinition = {
	id: 'searchValue',
	label: 'Search',
	filterType: 'text',
	defaultValue: '',
	componentProps: {
		className: 'search-filter'
	}
};

const severityFilter: ISelectFilterDefinition = {
	id: 'severities',
	label: 'Severity',
	filterType: 'select',
	defaultValue: [],
	componentProps: {
		placeholder: 'Select',
		allSelectedPlaceholder: 'All Severities',
		someItemsSelectedText: (numberOfItems: number) => `Severities (${numberOfItems})`,
		isMultiple: true,
		id: 'severities',
		label: 'Severity',
		listboxWidth: '150px'
	}
};

const issueTypeFilter: ISelectFilterDefinition = {
	id: 'types',
	label: 'Issue Type',
	filterType: 'select',
	defaultValue: [],
	componentProps: {
		placeholder: 'Select',
		allSelectedPlaceholder: 'All Issue Types',
		someItemsSelectedText: (numberOfItems: number) => `Issue Types (${numberOfItems})`,
		isMultiple: true,
		id: 'types',
		label: 'Issue Type',
		listboxWidth: '150px'
	}
};

const dateRangeFilter: ISelectFilterDefinition = {
	id: 'dateRange',
	label: 'Date range',
	filterType: 'select',
	defaultValue: [],
	componentProps: {
		placeholder: 'Last 30 days',
		isMultiple: false,
		id: 'dateRange',
		label: 'Date range',
		listboxWidth: '180px'
	}
};

export const getIssuesPageFilterDefinitions = (
	unitIdDisplayName: string = DEFAULT_UNIT_ID_DISPLAY_NAME,
	environmentDisplayName: string = DEFAULT_ENVIRONMENT_DISPLAY_NAME
): IFilterDefinition[] => {
	const unitIdFilter = createSingleSelectFilter(UNIT_ID_LABEL_KEY, unitIdDisplayName, {
		allSelectedPlaceholder: `All ${unitIdDisplayName}s`
	});

	const environmentFilter = createSingleSelectFilter(
		ENVIRONMENT_LABEL_KEY,
		environmentDisplayName,
		{
			allSelectedPlaceholder: `All ${environmentDisplayName}s`
		}
	);

	return [
		searchFilter,
		unitIdFilter,
		environmentFilter,
		severityFilter,
		issueTypeFilter,
		dateRangeFilter
	];
};
